import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown as falAngleDown } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown as fasAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { faCircleUser } from '@fortawesome/pro-light-svg-icons';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { faMobileButton } from '@fortawesome/pro-light-svg-icons';
import { faMobile } from '@fortawesome/pro-light-svg-icons';
import { faMagnifyingGlass as falMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { faMagnifyingGlass as fasMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { faAngleUp as falAngleUp } from '@fortawesome/pro-light-svg-icons';
import { faAngleUp as fasAngleUp } from '@fortawesome/pro-solid-svg-icons';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faChevronsLeft } from '@fortawesome/pro-regular-svg-icons';
import { faChevronsRight } from '@fortawesome/pro-regular-svg-icons';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faVimeoV } from '@fortawesome/free-brands-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';

library.add(faInstagram, faXTwitter, faFacebookF, faYoutube, faVimeoV, faLinkedinIn, faTiktok, falAngleDown, fasAngleDown, faCircleUser, faEnvelope, faMobileButton, faMobile, falMagnifyingGlass, fasMagnifyingGlass, falAngleUp, fasAngleUp, faArrowUpRightFromSquare, faCheck, faXmark, faCalendarPlus, faChevronLeft, faChevronRight, faChevronsLeft, faChevronsRight, faLock, faAngleRight);
dom.watch();
